import {
  readGrandTotal,
  readGrandTotalOrZero,
} from 'components/insights/careTransitions/shared/slideout/rollupHelpers';
import { Metrics } from 'components/insights/constants';
import { formatPercentage, formatWholeNumber } from 'components/insights/formatting';
import { useBusinessDevelopmentStore } from 'stores/businessDevelopmentStore';

import { SharedAnalytics } from '../BusinessDevelopmentDashboard';

import StatCard from './StatCard';

type Props = {
  careTransitions: SharedAnalytics;
  discharges: SharedAnalytics;
};

export default function MetricCardsRow({ careTransitions, discharges }: Props) {
  const groupTypeName = useBusinessDevelopmentStore((state) => state.selectedGroupType!.displayName);

  const volume = readGrandTotalOrZero(careTransitions.rollups, Metrics.LOCATION_EPISODE_ID_COUNT);
  const dischargeCount = readGrandTotalOrZero(discharges.rollups, Metrics.ID_COUNT);
  const readmissionRate = readGrandTotal(discharges.rollups, Metrics.READMISSION_RATE);

  return (
    <>
      <StatCard label={`${groupTypeName} Volume`} value={formatWholeNumber(volume)} loading={careTransitions.loading} />
      <StatCard
        label={`${groupTypeName} Discharges`}
        value={formatWholeNumber(dischargeCount)}
        loading={discharges.loading}
      />
      <StatCard
        label={`${groupTypeName} Readmission Rate`}
        value={formatPercentage(readmissionRate)}
        loading={discharges.loading}
      />
    </>
  );
}
